import { Button } from "@similarweb/ui-components";

import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { NT_PURCHASE_PAGE_LINK } from "app/pages/sales-intelligence/constants/common";
import { isTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";

import {
    CUSTOM_STYLES,
    StyledModalTitle,
    StyledModalSubtitle,
    StyledModalContent,
    StyledModalBody,
    StyledModalFooter,
    StyledCloseButton,
} from "./styles";

type RevealLimitReachedModalProps = {
    isOpened: boolean;
    onClose(): void;
};

const RevealLimitReachedModal = (props: RevealLimitReachedModalProps) => {
    const { isOpened, onClose } = props;
    const isTrialOrAfter = isTrialOrAfterTrial();

    const handleUpgradeNow = () => window.open(NT_PURCHASE_PAGE_LINK);

    const getContent = () => {
        if (isTrialOrAfter) {
            return (
                <>
                    <StyledModalBody>
                        <I18n
                            element={StyledModalTitle}
                            data-automation="reveal-limit-reached-modal.title-text"
                            translatable={{
                                key: "si.contacts-search.reveal-limit-reached-modal.title",
                            }}
                        />
                        <StyledModalSubtitle>
                            <I18n
                                data-automation="reveal-limit-reached-modal.subtitle-text"
                                translatable={{
                                    key: "si.contacts-search.reveal-limit-reached-modal.trial.subtitle",
                                }}
                            />
                        </StyledModalSubtitle>
                    </StyledModalBody>
                    <StyledModalFooter>
                        <StyledCloseButton
                            type="flat"
                            onClick={onClose}
                            dataAutomation="reveal-limit-reached-modal.close-button"
                        >
                            {translate("common.close")}
                        </StyledCloseButton>
                        <Button
                            type="primary"
                            onClick={handleUpgradeNow}
                            dataAutomation="reveal-limit-reached-modal.upgrade-button"
                        >
                            {translate("si.common.upgrade_now")}
                        </Button>
                    </StyledModalFooter>
                </>
            );
        }

        return (
            <>
                <StyledModalBody>
                    <I18n
                        element={StyledModalTitle}
                        data-automation="reveal-limit-reached-modal.title-text"
                        translatable={{
                            key: "si.contacts-search.reveal-limit-reached-modal.title",
                        }}
                    />
                    <StyledModalSubtitle>
                        <I18n
                            data-automation="reveal-limit-reached-modal.subtitle-text"
                            translatable={{
                                key: "si.contacts-search.reveal-limit-reached-modal.description",
                            }}
                        />
                    </StyledModalSubtitle>
                </StyledModalBody>
                <StyledModalFooter>
                    <Button
                        type="primary"
                        onClick={onClose}
                        dataAutomation="reveal-limit-reached-modal.close-button"
                    >
                        {translate("si.common.got-it")}
                    </Button>
                </StyledModalFooter>
            </>
        );
    };

    return (
        <ProModal
            isOpen={isOpened}
            showCloseIcon={false}
            customStyles={CUSTOM_STYLES}
            shouldCloseOnOverlayClick={false}
        >
            <StyledModalContent data-automation="reveal-limit-reached-modal">{getContent()}</StyledModalContent>
        </ProModal>
    );
};

export default RevealLimitReachedModal;
